import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';
import { handleApiError } from '../utils';
import { ApiResponse, TarifaDeliveryRangoFrontSimple } from '../dto';

@Injectable()
export class TarifaService {
	private endpoint = `/api/Tarifa`;

	constructor(private http: HttpClient) { }

	listarPorUbigeo(ListadoCodigos: string): Observable<ApiResponse<TarifaDeliveryRangoFrontSimple[]>> {
		return this.http.get<ApiResponse<TarifaDeliveryRangoFrontSimple[]>>(`${this.endpoint}/Listar/Distrito?codigos=${ListadoCodigos}`, { headers: { context: 'body' } }).pipe(
			catchError(handleApiError<TarifaDeliveryRangoFrontSimple[]>())
		);
	}

	listarPorZona(ListadoCodigos: string): Observable<ApiResponse<TarifaDeliveryRangoFrontSimple[]>> {
		return this.http.get<ApiResponse<TarifaDeliveryRangoFrontSimple[]>>(`${this.endpoint}/Listar/Zona?codigos=${ListadoCodigos}`, { headers: { context: 'body' } }).pipe(
			catchError(handleApiError<TarifaDeliveryRangoFrontSimple[]>())
		);
	}

}

